module.exports = __webpack_public_path__ + "img/stars.77ca2953.png";